<div class="outerContainer">
  <div class="addressContainer">
    <h1>{{ leiData.legalName.name }}</h1>
    <p>
      <span *ngFor="let addressLine of leiData.headquartersAddress.addressLines">{{ addressLine }}, </span>
    </p>
    <p>{{ leiData.headquartersAddress.postalCode }},</p>
    <p>{{ leiData.headquartersAddress.city }}, {{ leiData.headquartersAddress.country }}</p>
  </div>
  <div class="tickEditContainer">
    <p class="tick"></p>
    <button type="button" class="btn btn-link editButton" (click)="clickHandler()">EDIT</button>
  </div>
</div>
